import { useNavigate, NavLink } from "react-router-dom";
import { useState } from "react";
import Swal from "sweetalert2";
import "../styles/sidebar.css";

export default function Sidebar() {
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const closeSidebar = () => setSidebarOpen(false);

  const handleLogout = () => {
    Swal.fire({
      title: "Logout?",
      text: "Kya aap sach mein logout karna chahte hain?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Haan, Logout karein!",
      background: "#0f172a",
      color: "#fff",
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.clear();
        navigate("/login");
      }
    });
  };

  return (
    <>
      {/* 🔹 MOBILE TOP BAR */}
      <div className="mobile-topbar d-lg-none">
        <button
          className="mobile-toggle-btn"
          onClick={() => setSidebarOpen(true)}
        >
          <i className="fas fa-bars"></i>
        </button>
        <span className="mobile-title">BSC</span>
      </div>

      {/* 🔹 OVERLAY */}
      {sidebarOpen && (
        <div className="sidebar-overlay" onClick={closeSidebar}></div>
      )}

      {/* 🔹 SIDEBAR */}
      <div className={`sidebar ${sidebarOpen ? "open" : ""}`}>
        {/* ❌ CLOSE BUTTON */}
        <button className="sidebar-close d-lg-none" onClick={closeSidebar}>
          <i className="fas fa-times"></i>
        </button>

        <ul className="sidebar-links " onClick={closeSidebar}>
          <li className="mt-3">
            <NavLink to="/dashboard">
              <i className="fas fa-th-large"></i> Dashboard
            </NavLink>
          </li>
          <li>
            <NavLink to="/stock-management">
              <i className="fas fa-boxes"></i> Vehicle Stock
            </NavLink>
          </li>
          <li>
            <NavLink to="/create-bill">
              <i className="fas fa-file-invoice-dollar"></i> Create Bill
            </NavLink>
          </li>

          <li>
            <NavLink to="/dues">
              <i className="fas fa-exclamation-circle"></i>  View Dues
            </NavLink>
          </li>

        <li>
            <NavLink to="/all-history">
              <i className="fas fa-chart-line"></i> All History
            </NavLink>
          </li>

        </ul>

        <div className="sidebar-footer">
          <button className="logout-btn" onClick={handleLogout}>
            <i className="fas fa-sign-out-alt"></i> Logout
          </button>
        </div>
      </div>
    </>
  );
}
